module.exports = __webpack_public_path__ + "img/ideation-06-benchmarking-sample-04.74a8319e.jpg";